import Vue from 'vue'
import Router from 'vue-router'
import Auth from '../helpers/Auth'
import VerifyToken from '../helpers/VerifyToken'
import Login from '../components/Login'
import CriarConta from '../components/CriarConta'
import Home from '../components/Home'
import GerenciarEmpresa from '../components/GerenciarEmpresa'
import QueroTaxi from '../components/QueroTaxi'

//USUÁRIO ADMINISTRADOR
import Dashboard from '../components/user/Dashboard'
import Mensagens from '../components/user/Mensagens'
import InformesSms from '../components/user/mensagens/Informes'
import NovaMensagem from '../components/user/mensagens/NovaMensagem'
import ListarMensagens from '../components/user/mensagens/ListarMensagens'
import Mailing from '../components/user/Mailing'
import Campanhas from '../components/user/mensagens/Campanhas'
import ListarCampanhas from '../components/user/mensagens/ListarCampanhas'
import Documentacao from '../components/Documentacao'

import Templates from '../components/user/mensagens/Templates'

import Torpedovoz from '../components/user/Torpedovoz'
import Comprarcreditos from '../components/user/Comprarcreditos'
import Menuprotaxi from '../components/user/Menuprotaxi'
import InformesProtaxi from '../components/user/protaxi/Informes'
import Ligacoes from '../components/user/protaxi/Ligacoes'
import Ligar from '../components/user/protaxi/Ligar'
import Resumo from '../components/user/protaxi/Resumo'

import Push from '../components/user/Push'
import InformesPush from '../components/user/push/Informes'
import MinhasCampanhas from '../components/user/push/MinhasCampanhas'
import NovaCampanha from '../components/user/push/NovaCampanha'
import EnvioPush from '../components/user/push/EnvioPush'
import ListarPush from '../components/user/push/ListarPush'
import TemplatesPush from '../components/user/push/TemplatesPush'
import TemplatesNotificacaoPush from '../components/user/push/TemplatesNotificacaoPush'
import Envios from '../components/user/push/Envios'




import Pxtalk from '../components/user/Pxtalk'
import HistoricoAtendimento from '../components/user/pxtalk/HistoricoAtendimento'
import Taxistas from '../components/user/pxtalk/Taxistas'
import Agentes from '../components/user/pxtalk/Agentes'


import PerfilEmpresa from '../components/user/PerfilEmpresa'
import DadosEmpresa from '../components/user/empresa/DadosEmpresa'
import ListarUsuarios from '../components/user/empresa/ListarUsuarios'
import GruposEmpresa from '../components/user/empresa/GruposEmpresa'


//ROOT
import CadastrarCliente from '../components/root/CadastrarCliente'
import GerenciarRotas from '../components/root/GerenciarRotas'
import Sumarios from '../components/root/Sumarios.vue'
import ListarClientes from '../components/root/ListarClientes'
import HistoricoTransacao from '../components/root/HistoricoTransacao'





import Error404 from '../components/Error404'
Vue.use(Router)


let subFromMensagens = ["informes-sms", "listarmensagens", "novamensagem", "contatos", "agendamentos", "campanhas", "mailingsms"]
let subFromProtaxi = ["informes-protaxi", "resumo", "ligacoes", "ligar"]
let subFromPush = ["informes-push", "novacampanha", "minhascampanhas", "enviodepush", "historicopush", "modelosdenotificacao", "modelosdeenvio", "enviodeimagem"]
let subFromPxtalk = ["historicoatendimento", "taxistas", "agentes"]
let subFromEmpresa = ["dadosempresa", "listarusuarios", "gruposempresa"]


export default new Router({
    //mode:"history",
    routes: [{
            path: '/',
            redirect: "/home"
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            beforeEnter: VerifyToken
        },
        {
            path: '/criar-conta',
            name: 'criar-conta',
            component: CriarConta
        },
        {
            path: '/home',
            name: 'home',
            component: Home,
            beforeEnter: Auth
        },

        {
            path: '/quero-taxi',
            name: 'quero-taxi',
            component: QueroTaxi,
            meta: {
                actions: ["listarquerotaxi"]
            },
            beforeEnter: Auth
        },


        // ROTAS DO ROOT
        {
            path: '/sumarios',
            name: 'sumarios',
            component: Sumarios,
            meta: {
                actions: ["listarsumarios"]
            },
            beforeEnter: Auth
        },
        {
            path: '/listar-clientes',
            name: 'listar-clientes',
            component: ListarClientes,
            meta: {
                actions: ["listar", "editar"]
            },
            beforeEnter: Auth
        },

        {
            path: '/historicotransacoes',
            name: 'historicotransacoes',
            component: HistoricoTransacao,
            meta: {
                actions: ["listartransacoes", "editartransaçoes"]
            },
            beforeEnter: Auth
        },
        /*{
          path: '/listarclientes',
          name: 'listarclientes',
          component: ListarClientes,
          meta:{
            actions: ["consultar","editar","excluir"]
          },
        beforeEnter:Auth
        },
        {
          path: '/gerenciarrotas',
          name: 'gerenciarrotas',
          component: GerenciarRotas,
          meta:{
            actions: ["incluir","consultar","editar","excluir"]
          },
        beforeEnter:Auth
        },*/








        //USUÁRIOS - EMPRESAS
        {
            path: '/dashboard',
            name: 'dashboard',
            component: Dashboard,
            meta: {
                actions: ["mostrardashboard"]
            },
            beforeEnter: Auth
        },
        {
            path: '/documentacao',
            name: 'documentacao',
            component: Documentacao,
            meta: {
                actions: ["listardocumentacao"]
            },
            beforeEnter: Auth
        },
        {
            path: '/gerenciarempresa',
            name: 'gerenciarempresa',
            component: GerenciarEmpresa,
            meta: {
                actions: ["mostrargerenciamentodeempresa"]
            },
            beforeEnter: Auth
        },
        {
            path: '/mensagens',
            name: 'mensagens',
            component: Mensagens,
            //redirect:"/novamensagem",
            meta: {
                subroutes: [...subFromMensagens],
                actions: ["mostrarmensagens"],

            },
            beforeEnter: Auth,
            children: [
                {
                    path: '/informes-sms',
                    name: 'informes-sms',
                    component: InformesSms,
                    meta: {
                        subroutes: [...subFromMensagens],
                        actions: ["listarinformessms"],
                        fullAccess: true,
                    },
                    beforeEnter: Auth
                },
                {
                    path: '/listarmensagens',
                    name: 'listarmensagens',
                    component: ListarMensagens,
                    meta: {
                        subroutes: [...subFromMensagens],
                        actions: ["listarmensagens"]
                    },
                    beforeEnter: Auth
                },
                {
                    path: '/novamensagem',
                    name: 'novamensagem',
                    meta: {
                        subroutes: [...subFromMensagens],
                        actions: ["novamensagem"]
                    },
                    component: NovaMensagem,
                    beforeEnter: Auth
                },
                {
                    path: '/contatos',
                    name: 'contatos',
                    component: Mailing,
                    meta: {
                        subroutes: [...subFromMensagens],
                        actions: ["importarcontatos"]
                    },
                    beforeEnter: Auth
                },
                {
                    path: '/agendamentos',
                    name: 'agendamentos',
                    component: Campanhas,
                    meta: {
                        subroutes: [...subFromMensagens],
                        actions: ["listarcampanhas", "criarcampanhas"]
                    },
                    beforeEnter: Auth
                },
                {
                    path: '/campanhas',
                    name: 'campanhas',
                    component: ListarCampanhas,
                    meta: {
                        subroutes: [...subFromMensagens],
                        actions: ["listaragendamentos"]
                    },
                    beforeEnter: Auth
                },

                /*{
                    path: '/templatemensagens',
                    name: 'templatemensagens',
                    component: Templates,
                    meta: {
                        subroutes: [...subFromMensagens],
                        actions: ["listatemplates"]
                    },
                    beforeEnter: Auth
                },*/

            ]
        },
        {
            path: '/torpedovoz',
            name: 'torpedovoz',
            component: Torpedovoz,
            meta: {
                actions: ["mostrartorpedovoz"]
            },
            beforeEnter: Auth
        },
        {
            path: '/comprarcreditos',
            name: 'comprarcreditos',
            component: Dashboard, //Comprarcreditos,
            meta: {
                actions: ["mostrarcomprarcreditos"]
            },
            beforeEnter: Auth
        },
        {
            path: '/menuprotaxi',
            name: 'menuprotaxi',
            component: Menuprotaxi,
            meta: {
                subroutes: [...subFromProtaxi],
                actions: ["mostrarmenuprotaxi"]
            },
            //redirect:"/resumo",
            beforeEnter: Auth,
            children: [
                {
                    path: '/informes-protaxi',
                    name: 'informes-protaxi',
                    component: InformesProtaxi,
                    meta: {
                        subroutes: [...subFromProtaxi],
                        actions: ["listarinformesprotaxi"],
                        fullAccess: true,
                    },
                    beforeEnter: Auth
                },
                {
                    path: '/resumo',
                    name: 'resumo',
                    component: Resumo,
                    meta: {
                        subroutes: [...subFromProtaxi],
                        actions: ["listarligacoes"]
                    },
                    beforeEnter: Auth
                },
                /*{
                  path: '/ligacoes',
                  name: 'ligacoes',
                  component: Ligacoes,
                  meta:{
                    actions: ["consultar"]
                  },
                beforeEnter:Auth
                },*/
                {
                    path: '/ligar',
                    name: 'ligar',
                    component: Ligar,
                    meta: {
                        subroutes: [...subFromProtaxi],
                        actions: ["realizarligacao"]
                    },
                    beforeEnter: Auth
                }
            ]
        },
        {
            path: '/push',
            name: 'push',
            meta: {
                subroutes: [...subFromPush],
                actions: ["mostrarpush"]
            },
            component: Push,
            beforeEnter: Auth,
            children: [
                /*{
                    path: '/novacampanha',
                    name: 'novacampanha',
                    component: NovaCampanha,
                    meta:{
                        subroutes:[...subFromPush],
                        actions: ["cadastrarcampanha"]
                    },
                    beforeEnter:Auth
                },
                {
                  path: '/minhascampanhas',
                  name: 'minhascampanhas',
                  component: MinhasCampanhas,
                  meta:{
                    subroutes:[...subFromPush],
                    actions: ["listarcampanhas"]
                  },
                beforeEnter:Auth
                },*/
                {
                    path: '/informes-push',
                    name: 'informes-push',
                    component: InformesPush,
                    meta: {
                        subroutes: [...subFromPush],
                        actions: ["listarinformespush"],
                        fullAccess: true,
                    },
                    beforeEnter: Auth
                },
                {
                    path: '/enviodepush',
                    name: 'enviodepush',
                    component: EnvioPush,
                    meta: {
                        subroutes: [...subFromPush],
                        actions: ["enviarpush"]
                    },
                    beforeEnter: Auth
                },
                {
                    path: '/historicopush',
                    name: 'historicopush',
                    component: ListarPush,
                    meta: {
                        subroutes: [...subFromPush],
                        actions: ["listarenviospush"]
                    },
                    beforeEnter: Auth
                },
                {
                    path: '/modelosdenotificacao',
                    name: 'modelosdenotificacao',
                    component: TemplatesNotificacaoPush,
                    meta: {
                        subroutes: [...subFromPush],
                        actions: ["listarmodelos"]
                    },
                    beforeEnter: Auth
                },
                {
                    path: '/modelosdeenvio',
                    name: 'modelosdeenvio',
                    component: TemplatesPush,
                    meta: {
                        subroutes: [...subFromPush],
                        actions: ["listarmodelosdeenvio"]
                    },
                    beforeEnter: Auth
                },
                {
                    path: '/enviodeimagem',
                    name: 'enviodeimagem',
                    component: Envios,
                    meta: {
                        subroutes: [...subFromPush],
                        actions: ["listarenvios", "enviarimagem"]
                    },
                    beforeEnter: Auth
                },
            ]
        },
        {
            path: '/pxtalk',
            name: 'pxtalk',
            meta: {
                subroutes: [...subFromPxtalk],
                actions: ["mostrarpxtalk"]
            },
            component: Pxtalk,
            beforeEnter: Auth,
            children: [{
                    path: '/historicoatendimento',
                    name: 'historicoatendimento',
                    component: HistoricoAtendimento,
                    meta: {
                        subroutes: [...subFromPxtalk],
                        actions: ["listarhistoricoatendimento"]
                    },
                    beforeEnter: Auth
                },
                {
                    path: '/taxistas',
                    name: 'taxistas',
                    component: Taxistas,
                    meta: {
                        subroutes: [...subFromPxtalk],
                        actions: ["listartaxistas", "cadastrartaxista", "alterartaxista", "removertaxista"]
                    },
                    beforeEnter: Auth
                },
                {
                    path: '/agentes',
                    name: 'agentes',
                    component: Agentes,
                    meta: {
                        subroutes: [...subFromPxtalk],
                        actions: ["listaragentes", "cadastraragente", "alteraragente", "removeragente", "gerenciarstatus"]
                    },
                    beforeEnter: Auth
                }
            ]
        },
        {
            path: '/perfilempresa',
            name: 'perfilempresa',
            component: PerfilEmpresa,
            //redirect:"/dadosempresa",
            meta: {
                subroutes: [...subFromEmpresa],
                actions: ["mostrarperfilempresa"]
            },
            beforeEnter: Auth,
            children: [{
                    path: '/dadosempresa',
                    name: 'dadosempresa',
                    component: DadosEmpresa,
                    meta: {
                        subroutes: [...subFromEmpresa],
                        actions: ["listardadosempresa", "alterardadosempresa"]
                    }
                },
                {
                    path: '/listarusuarios',
                    name: 'listarusuarios',
                    component: ListarUsuarios,
                    meta: {
                        subroutes: [...subFromEmpresa],
                        actions: ["listarusuarios", "cadastrarusuario", "alterarusuario", "removerusuario"]
                    }
                },
                {
                    path: '/gruposempresa',
                    name: 'gruposempresa',
                    component: GruposEmpresa,
                    meta: {
                        subroutes: [...subFromEmpresa],
                        actions: ["listargruposempresa", "cadastrargruposempresa", "alterargruposempresa", "removergruposempresa"]
                    }
                },
            ]
        },
        {
            path: '*',
            name: '404',
            component: Error404
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js